import Vue from 'vue'
import IconSvg from '@/components/icons/index.vue'
//全局注册组件
Vue.component('icon-svg', IconSvg)
//引入所有svg文件
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
